import { render, staticRenderFns } from "./Composition.vue?vue&type=template&id=7cfb38c6&scoped=true"
import script from "./Composition.vue?vue&type=script&lang=ts"
export * from "./Composition.vue?vue&type=script&lang=ts"
import style0 from "./Composition.vue?vue&type=style&index=0&id=7cfb38c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb38c6",
  null
  
)

export default component.exports